import React from 'react';
import { useSelector } from 'react-redux';

import { ContentClass } from '../../app/Shared/enums';
import Duration from '../../common/components/Duration';
import { startCase } from '../../common/utils';
import { selectDetailsStockItem } from '../selectors/detailsSelectors';
import LegalDisclaimerTooltip from './LegalDisclaimerTooltip';

function seoApprovedH1Title(h1title = '') {
  // replace accented letter with non-accented letters
  h1title = h1title.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  // replace special chars
  h1title = h1title.replace(/[^a-z A-Z0-9]/g, '');
  // capitalize the first letter of each word
  // ensure that DaVinci Resolve is not using startCase, but other Da Vinci keywords still retain Start Case.
  return startCase(h1title).replace(/Da Vinci Resolve/g, 'DaVinci Resolve');
}

const StockItemTitle = () => {
  const stockItem = useSelector(selectDetailsStockItem);
  let title = seoApprovedH1Title(stockItem.title);

  if (stockItem.contentType === 'snapshot') {
    title = `Still Image of ${seoApprovedH1Title(stockItem.title)}`;
  }

  return (
    <div className="stockItemInfo flex">
      <h1 className="stockItemInfo-title" data-selenium-value={title}>
        {title}
        {stockItem.contentClass === ContentClass.Video && (
          <>
            &nbsp;
            <Duration seconds={stockItem.duration} />
          </>
        )}
        {stockItem.contentType === 'snapshot' && <LegalDisclaimerTooltip />}
      </h1>
    </div>
  );
};

export default StockItemTitle;
